export default __webpack_public_path__ + "static/media/amex@1,5x.d61710b4.svg";